import React from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { RiCloseCircleLine } from "react-icons/ri";
import { useState } from "react";

function Header() {
  const [showList, setShowList] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleOpenMenu = () => {
    setShowList(true);
    setOpenMenu(true);
  };
  const handleCloseMenu = () => {
    setShowList(false);
    setOpenMenu(false);
  };
  const handleList =()=>{
    setShowList(false);
    setOpenMenu(false);
  }
  return (
    <>
      <header>
      <div className="container ps-0">
        <nav className="d-flex justify-content-between  align-items-center">
        <div className="d-flex align-items-center">
            <a href="/">
              <img
                src="dist/img/icici_logo.webp"
                alt="ICICI Bank Logo"
                width="252"
                height="50"
                className="img-fluid"
              />
            </a>
          </div>
          <ul className="d-flex mb-0 list_item d-none d-lg-flex">
            
            <li>
            <a href="#benefits"> Benefits</a>
            </li>
            <li>
             
              <a href="#FD_calculator">FD Calculator</a>
            </li>
            <li>
              <a href="#faq"> FAQs</a>
            </li>
          </ul>
       
        {openMenu ? (
          <div className="d-block d-lg-none close_menu">
            <RiCloseCircleLine className="close" onClick={handleCloseMenu} />
          </div>
        ) : (
          <div className="d-block d-lg-none hamburger_menu me-2">
            <RxHamburgerMenu className="hamburger" onClick={handleOpenMenu} />
          </div>
        )}

        {showList && (
          
          <ul className=" mob_list d-flex justify-content-center flex-column">
           
           {/**  <li>
              <a href="#services" onClick={handleList} className="services"> Services
              </a>
            </li>*/}
           
            <li>
              <a href="#benefits" onClick={handleList}> Benefits</a>
            </li>
            <li>
            <a href="#FD_calculator" onClick={handleList}> FD Calculator</a>
          </li>
            
            <li>
              <a href="#faq" onClick={handleList}> FAQs</a>
            </li>
          </ul>
        )}
      </nav>
      </div>
      </header>
    </>
  );
}

export default Header;
